import { Progression } from '@ispm-shared/modules/common';
import { CurationItemId } from '../models';

export interface State {
  pathwayTestProgression?: Progression;
  bpmnNodesCurationData?: any;
  curationItemId?: CurationItemId;
  clinicalTrials?: any;
  clinicalTrialStatuses?: string[];
  curationItemApprovalStatuses?: string[];
  knowledgeBase?: string;
  bpmnType?: string;
  bpmnLinkedResourcesType?: string;
  bpmnConnectingResourcesType?: string;
  bpmnAttachedResourcesType?: string;
  pathwaysIsPrefetched: boolean;

}

export const initialState: State = {
  pathwayTestProgression: null,
  bpmnNodesCurationData: null,
  curationItemId: null,
  clinicalTrials: null,
  clinicalTrialStatuses: null,
  curationItemApprovalStatuses: null,
  knowledgeBase: null,
  bpmnType: null,
  bpmnLinkedResourcesType: null,
  bpmnConnectingResourcesType: null,
  bpmnAttachedResourcesType: null,
  pathwaysIsPrefetched: false
};
